export default "__VITE_ASSET__1be948f4__"